/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type ExportToolsDestroyRequest = {} | null | undefined;
export type ExportToolsDestroyResponse = any;

export type ExportToolsDestroyQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this export tool.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * DELETE /dmx-server/export_tools/{id}/
 *
 * ```yaml
 * operationId: export_tools_destroy
 * tags:
 *   - export_tools
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '204':
 *     description: No response body
 * ```
 */
export const exportToolsDestroyOperation = ({ id, ...rest }: ExportToolsDestroyQuery) =>
  ({
    method: 'DELETE',
    path: `/dmx-server/export_tools/${id}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'DELETE';
    path: string & { _templateUrl: '/dmx-server/export_tools/{id}/' };
  };

/**
 * DELETE /dmx-server/export_tools/{id}/
 *
 * ```yaml
 * operationId: export_tools_destroy
 * tags:
 *   - export_tools
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '204':
 *     description: No response body
 * ```
 */
export const exportToolsDestroy = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: ExportToolsDestroyQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = exportToolsDestroyOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'DELETE',
    request,
    onUploadProgress,
    cancelToken,
  );
};
